import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const TechnologyResults = () => {
  const results = [
    'Faster partner activation',
    'Stronger performance across the ecosystem',
    'Less friction for enablement teams',
    'Training that actually scales with your platform'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            The Result
          </h2>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="grid md:grid-cols-2 gap-4">
            {results.map((result, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-green-900/20 to-cyan-900/20 border border-green-500/30"
              >
                <CheckCircle2 className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{result}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnologyResults;
